<template>
  <div>
    <data-table :service="ClientUserService"
                :entity="entity"
                :columns="columns"
                row-navigation-key="user_uuid"
                row-delete-key="uuid"
                ref="table">
      <div class="d-flex align-items-center" slot="name" slot-scope="{row}">
        <base-avatar :user="row"
                     :src="row.image">
        </base-avatar>
        <div class="ml-2 font-weight-bold">{{row.given_name}}</div>
      </div>
      <template slot="email" slot-scope="{row}">
        {{row.email}}
      </template>

      <router-link :to="`/contacts/clients/${row.client_uuid}`" slot="client_name" slot-scope="{row}">
        {{row.client_name}}
      </router-link>

      <template slot="created_at" slot-scope="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:active="{row}">
        <status-badge :status="row.active ? $t('generic.active'): $t('generic.inactive')"/>
      </template>
      <template v-slot:extra-buttons="{row}">
        <tooltip-icon-button v-if="!row.active"
                             type="success"
                             :content="$t('generic.user.activate')"
                             icon="nc-icon nc-check-2"
                             @click.stop="activateUser(row)"/>
      </template>
    </data-table>
  </div>
</template>
<script>
  import ClientUserService from 'src/services/ClientUserService'
  import TooltipIconButton from 'src/components/Buttons/TooltipIconButton'
  import entities from 'src/config/entities'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'user-list',
    components: {
      TooltipIconButton
    },
    data () {
      return {
        FRIENDLY_DATETIME_FORMAT,
        ClientUserService,
        entity: entities.USER
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('user.list.labels.name'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'email',
            label: this.$t('user.list.labels.email'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'client_name',
            label: this.$t('user.list.labels.clientName'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'active',
            label: this.$t('generic.status'),
            minWidth: '150px',
            sortable: true
          }
        ]
      }
    },
    methods: {
      async activateUser (row) {
        await ClientUserService.activateClientUser(row.uuid)
      }
    }
  }
</script>
<style>
</style>
